<template>
  <b-form-group
    label="Metin Değeri 1"
    label-for="str_value_1"
  >
    <b-form-input
      id="str_value_1"
      v-model="dataItem.str_value_1"
      placeholder="Metin Değeri 1"
    />
  </b-form-group>
</template>

<script>
import { localize } from 'vee-validate'
import {
  BFormGroup, BFormInput,
} from 'bootstrap-vue'
import { required } from '@validations'

export default {
  name: 'ParamsStringValue1',
  components: {
    BFormGroup,
    BFormInput,
  },
  data() {
    return {
      required,
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['params/dataItem']
    },
  },
  created() {
    localize('tr')
  },
}
</script>

<style scoped>

</style>
